import React from "react";
import { ContentItem } from "@api";
import BaseSlider from "@/components/BaseSlider/BaseSlider";

interface IFirstModularPodSwiperProps {
  pageContent: Record<string, ContentItem>;
  children: React.ReactNode;
}

// Same config as the live Swiper (slidesPerView 1.4, spaceBetween 14, default draggable
// scrollbar), minus Swiper itself: BaseSlider is now a SnapSlider adapter.
const FirstModularPodSwiper = ({
  pageContent,
  children,
}: IFirstModularPodSwiperProps) => {
  return (
    <BaseSlider
      sliderProps={{
        slidesPerView: 1.4,
        spaceBetween: 14,
      }}
    >
      {children}
    </BaseSlider>
  );
};

export default FirstModularPodSwiper;
